const initialState = {
    loading : false,
    loadingSupplier : false,
    loadingSupplierProduct : false,
    supplierProducts: [],
    authSupplierProducts: [],
    subcategory: [],
    supplierProductDetail: {},
    supplierDetails: [],
    supplierDetail: [],
};


const projectReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SUPPLIER_PRODUCT_LIST_PENDING":
            state = {
                ...state,
                loadingSupplierProduct: true,
            };
            break;
        case "SUPPLIER_PRODUCT_LIST_FULFILLED":
            state = {
                ...state,
                loadingSupplierProduct: false,
                supplierProducts: action.payload,
                supplierDetails: action.payload?.supplierDetails,
            };
            break;
        case "SUPPLIER_PRODUCT_LIST_REJECTED":
            state = {
                ...state,
                loadingSupplierProduct: false,
                errors: action.payload.data,
            };
            break;
        case "SUB_CATEGORIES":
            state = {
                ...state,
                loading: true,
                customizeSuccess: false,
                errors: {},
            };
            break;
        case "SUB_CATEGORIES_FULFILLED":
            state = {
                ...state,
                loading: false,
                customizeSuccess: false,
                subcategory: action.payload.subcategory,
            };
            break;
        case "SUB_CATEGORIES_REJECTED":
            state = {
                ...state,
                loading: false,
                customizeSuccess: false,
                errors: action.payload.data,
            };
            break;
        case "SUPPLIER_PRODUCT_DETAIL_PENDING":
            state = {
                ...state,
                loadingSupplierProduct: true,
            };
            break;
        case "SUPPLIER_PRODUCT_DETAIL_FULFILLED":
            state = {
                ...state,
                loadingSupplierProduct: false,
                supplierProductDetail: action.payload?.supplierProduct,
            };
            break;
        case "SUPPLIER_PRODUCT_DETAIL_REJECTED":
            state = {
                ...state,
                loadingSupplierProduct: false,
                errors: action.payload.data,
            };
            break;
        case "SUPPLIER_DETAILS_PENDING":
            state = {
                ...state,
                loadingSupplier: true,
            };
            break;
        case "SUPPLIER_DETAILS_FULFILLED":
            state = {
                ...state,
                loadingSupplier: false,
                supplierDetail: action.payload?.supplier,
            };
            break;
        case "SUPPLIER_DETAILS_REJECTED":
            state = {
                ...state,
                loadingSupplier: false,
                errors: action.payload.data,
            };
            break;
    }

    return state;
};

export default projectReportReducer;
